import { component } from 'picoapp';
import formatMoney from 'utils/format-money';

export default component(async (node) => {
  const rangeMin = node.querySelector<HTMLInputElement>('[data-range-min]');
  const rangeMax = node.querySelector<HTMLInputElement>('[data-range-max]');
  const labelMin = node.querySelector('[data-label-min]');
  const labelMax = node.querySelector('[data-label-max]');
  const trackFill = node.querySelector<HTMLElement>('[data-track-fill]');

  const init = () => {
    [rangeMin, rangeMax].forEach((input) => {
      input.addEventListener('input', () => {
        let minValue = parseInt(rangeMin.value, 10);
        let maxValue = parseInt(rangeMax.value, 10);

        if (input === rangeMin && minValue >= maxValue) {
          minValue = maxValue - 1;
        }

        if (input === rangeMax && maxValue <= minValue) {
          maxValue = minValue + 1;
        }

        rangeMin.value = minValue.toString();
        rangeMax.value = maxValue.toString();

        labelMin.textContent = `${formatMoney(minValue * 100)}`;
        labelMax.textContent = `${formatMoney(maxValue * 100)}`;

        const fillLeft = `${(minValue / parseInt(rangeMin.max, 10)) * 100}%`;
        const fillRight = `${100 - ((maxValue / parseInt(rangeMax.max, 10)) * 100)}%`;

        trackFill.style.left = fillLeft;
        trackFill.style.right = fillRight;
      });
    });
  };

  init();
});
